/**
 * NV Alert component.
 *
 * @param editor
 * @param options
 */
export default function (editor, options) {
  editor.DomComponents.addType(options.componentType, {
    model: {
      defaults: {
        tagName: 'div',
        draggable: true,
        droppable: false,
        stylable: true,
        editable: true,
        name: options.componentName,
        classes: options.css.root,
        traits: [
          {
            type: 'select',
            label: 'Style',
            name: 'alertStyle',
            options: [
              {value: 'nv-alert', name: 'Default'},
              {value: 'nv-alert nv-alert--info', name: 'Info'},
              {value: 'nv-alert nv-alert--success', name: 'Success'},
              {value: 'nv-alert nv-alert--warning', name: 'Warning'},
              {value: 'nv-alert nv-alert--error', name: 'Error'},
            ],
            changeProp: 1,
          },
          {
            type: 'checkbox',
            label: 'Dismissable',
            name: 'dismissable',
            valueTrue: true,
            valueFalse: false,
            changeProp: 1,
          },
          {
            type: 'checkbox',
            label: 'Show icon',
            name: 'showIcon',
            valueTrue: true,
            valueFalse: false,
            changeProp: 1,
          },
        ],
        attributes: {
          'role': 'alert',
        },
        alertStyle: 'nv-alert',
        dismissable: true,
        showIcon: true,
        components: components(),
      },
      init() {
        this.listenTo(this, 'change:alertStyle', this.handleClasses);
        this.listenTo(this, 'change:dismissable', this.handleClasses);
        this.listenTo(this, 'change:showIcon', this.handleClasses);
      },
      handleClasses() {
        const newStyles = this.get('alertStyle');
        const isDismissable = this.get('dismissable');
        const showIcon = this.get('showIcon');

        let classList = [...options.css.root, ...newStyles.split(' ')];

        if (!isDismissable) {
          classList = classList.filter(item => item !== 'alert-dismissible')
        }

        if (!showIcon) {
          classList = classList.filter(item => item !== 'nv-alert--with-icon')
        }

        this.setClass(classList);
      }
    },
  });
}

function components() {
  return [
    {
      tagName: 'div',
      classes: ['nv-alert__icon'],
      editable: false,
      removable: false,
    },
    {
      tagName: 'div',
      classes: ['nv-alert__content'],
      components: [
        {
          tagName: 'h4',
          type: 'header',
          content: 'NVIDIA Developer Program',
          classes: ['alert-heading'],
          editable: true,
        },
        {
          tagName: 'p',
          type: 'paragraph',
          content: 'An online space with free SDKs, technical documentation, expert support, and hardware info to help you tackle your biggest challenges.',
          classes: [],
          editable: true,
        },
      ],
    },
    {
      tagName: 'div',
      classes: ['nv-alert__links'],
      components: [
        {
          tagName: 'a',
          type: 'link',
          href: 'https://developer.nvidia.com/developer-program',
          content: 'Join Now',
          classes: ['nv-cta-secondary', 'nv-cta-secondary--small'],
          editable: true,
        },
      ]
    },
    {
      tagName: 'button',
      classes: ['btn-close'],
      editable: false,
      attributes: {
        'type': 'button',
        'data-bs-dismiss': 'alert',
        'aria-label': 'Close'
      },
      dismissableBtn: true,
    }
  ];
}
